package fr.frux.feature.treedetail

import androidx.compose.runtime.Composable
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_harvest_status_cancelled
import fr.frux.feature.treedetail.resources.treedetail_harvest_status_completed
import fr.frux.feature.treedetail.resources.treedetail_harvest_status_expired
import fr.frux.feature.treedetail.resources.treedetail_harvest_status_ongoing
import fr.frux.feature.treedetail.resources.treedetail_harvest_status_planned
import fr.frux.shared.domain.model.HarvestStatus
import org.jetbrains.compose.resources.stringResource

/** « Passée » (#435) prime sur le statut, qui n'a pas bougé en base. */
@Composable
internal fun TreeHarvestItem.statusLabel(): String =
    if (expired) stringResource(Res.string.treedetail_harvest_status_expired) else status.shortLabel()

/** Libellé court, indépendant du DTO (#109) — [HarvestStatus.COMPLETED]/[HarvestStatus.CANCELLED]
 *  n'apparaissent jamais ici (filtre en amont dans le ViewModel) mais restent gérés pour rester
 *  exhaustif sur l'enum. */
@Composable
private fun HarvestStatus.shortLabel(): String =
    when (this) {
        HarvestStatus.PLANNED -> stringResource(Res.string.treedetail_harvest_status_planned)
        HarvestStatus.ONGOING -> stringResource(Res.string.treedetail_harvest_status_ongoing)
        HarvestStatus.COMPLETED -> stringResource(Res.string.treedetail_harvest_status_completed)
        HarvestStatus.CANCELLED -> stringResource(Res.string.treedetail_harvest_status_cancelled)
    }
